'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'transporter';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e042';
var svgPathData = 'M264 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM204.8 191.1c1-1.7 2.1-3.4 3.2-5l0 293.9 32 0 0-112 96 0 0 112 32 0 0-293.9c1.1 1.6 2.2 3.3 3.2 5l63.1 105.1c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-21.9L398.6 174.6C375.3 135.8 333.3 112 288 112s-87.3 23.8-110.6 62.6L114.3 279.8c-4.5 7.6-2.1 17.4 5.5 21.9s17.4 2.1 22-5.5l63.1-105.1zM224 544l208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0zM336 336l-96 0 0-179.3c14.4-8.2 30.9-12.7 48-12.7s33.6 4.5 48 12.7L336 336zM64 96L56.7 70.6C55.6 66.7 52.1 64 48 64s-7.6 2.7-8.7 6.6L32 96 6.6 103.3C2.7 104.4 0 107.9 0 112s2.7 7.6 6.6 8.7L32 128 39.3 153.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 128 89.4 120.7c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 96zM536.7 6.6C535.6 2.7 532.1 0 528 0s-7.6 2.7-8.7 6.6L512 32 486.6 39.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L512 64 519.3 89.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L544 64 569.4 56.7c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L544 32 536.7 6.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTransporter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;